<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Real Estate Investing 101: From Finding Properties and Securing Mortgage Terms to REITs and Flipping Houses, an Essential Primer on How to Make Money with Real Estate, by CPA  Michele Cagan." class="imagefp" src="images/9781507210581.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?5696c672